<app-pias-layout>
  <div pias-layout-content>
    <div id="download-resource-container" class="container-fluid">
      <div id="download-resource-header">
        <h5 class="page-header">Download Resource</h5>
      </div>

      <div id="download-resource-body" class="w-100">
        <div id="download-resource-filter-form" class="w-100">
          <form class="row align-items-start" [formGroup]="downloadResourceFg">
            <div class="col-sm-12 col-md-7 col-lg-5 col-xxl-5 m-0">
              <!-- <mat-form-field class="w-100">
                                <mat-label>Search keyword</mat-label>
                                <input matInput formControlName="searchKeyword" type="text"
                                    placeholder="Search by Keyword..." />
                            </mat-form-field> -->
              <div class="position-relative" style="max-width: 500px">
                <input type="text" class="form-control border-0 shadow-sm ps-5 pe-5"
                  style="background: #f0f0f0; color: #1c3a7a" formControlName="searchKeyword"
                  (keyup)="__applyDownloadResourceFilter()" placeholder="Search by keyword..." />

                <!-- Search icon -->
                <i class="fas fa-search position-absolute top-50 start-0 ms-3 translate-middle-y"
                  style="color: #888888"></i>

                <!-- Clear button -->
                <button type="button" *ngIf="downloadResourceFg.get('searchKeyword')?.value"
                  class="btn position-absolute top-50 end-0 translate-middle-y me-3 p-0 border-0 bg-transparent"
                  (click)="clearSearch()">
                  <i class="fas fa-times" style="color: #888888"></i>
                </button>
              </div>
            </div>
            <div class="col-sm-12 col-md-5 col-lg-6 col-xxl-6 m-0">
              <div class="position-relative" style="max-width: 300px;">
                <!-- Filter icon -->
                <i class="fas fa-chevron-down position-absolute top-50 end-0 me-3 translate-middle-y"
                  style="color: #888888; pointer-events: none; cursor: pointer;"></i>

                <select class="form-select shadow-sm" style="background: #f0f0f0; color: #504f4f; cursor: pointer;"
                  formControlName="drCategory" (change)="__applyDownloadResourceFilter()">
                  <option value="" selected>All categories</option>
                  @for (category of downloadResourceCategoryOptions; track category) {
                  <option [value]="category.value">
                    {{ category.name }}
                  </option>
                  }
                </select>
              </div>

              <!-- <mat-form-field class="w-100">
                <mat-label>Category</mat-label>
                <mat-select formControlName="drCategory">
                  @for(category of this.downloadResourceCategoryOptions; track category) {
                  <mat-option value="{{ category.value }}">{{ category.name }}</mat-option>
                  }
                </mat-select>
              </mat-form-field> -->
            </div>
            <p class="col-sm-12 col-md-1 col-lg-4 col-xxl-3 m-0">
              <!-- <button type="submit" class="btn-pias"
                                (click)="this.__applyDownloadResourceFilter()">Search</button> -->
            </p>
          </form>
        </div>

        <mat-divider></mat-divider>
        <div id="download-resource-list-container">
          <mat-paginator [length]="downloadResourceLength" [pageSize]="downloadResourcePageSize" showFirstLastButtons
            [pageSizeOptions]="[10, 20, 50]" (page)="__downloadResourceOnPageChange()">
          </mat-paginator>

          <div class="file-list-container mt-3">
            @for (drItem of this.downloadResourceListDataSource; track drItem) {
            <div class="card-container">
              <div class="icon-box">
                <span class="file-icon">
                  @if(['pdf'].includes(this.__getFileType(drItem.resourceLink))) {
                  <i class="bi bi-file-earmark-pdf-fill"></i>
                  } @else if (['xlsb','xlsm'].includes(this.__getFileType(drItem.resourceLink))) {
                  <i class="bi bi-file-earmark-spreadsheet-fill"></i>
                  } @else {
                  <i class="bi bi-file-earmark-text-fill"></i>
                  }
                </span>
              </div>

              <div class="content-box">
                <div class="meta">
                  <span class="type">{{ drItem.resourceCategoryName }}</span>
                </div>

                <div class="title">{{ drItem.resourceTitle }}</div>
              </div>

              @if(['pdf'].includes(this.__getFileType(drItem.resourceLink))) {
              <div class="action-box">
                <a class="download-link" (click)="this.__printDownloadResource(drItem.resourceLink)">
                  <mat-icon>print</mat-icon>
                </a>
              </div>
              }

              <div class="action-box">
                <a (click)="this.__userLogDocument(drItem.resourceLink)" class="download-link">
                  <mat-icon>download</mat-icon>
                </a>
              </div>
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</app-pias-layout>